import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faTrash, faPen } from '@fortawesome/free-solid-svg-icons';

const truncate = (text, max) => (text?.length > max ? text.slice(0, max) + '...' : text);
const slugify = (text) => {
  return text
    .toString()                          
    .toLowerCase()                       
    .trim()                              
    .replace(/\s+/g, '-')                
    .replace(/[^\w\-]+/g, '')            
    .replace(/\-\-+/g, '-');             
};  
const ArticlesTable = ({
  articles,
  onSetFeatured,
  onEdit,
  onDelete,
  showIndex = false,
  startIndex = 0
}) => {
  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    const date = timestamp.toDate();
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
  };

  return (
    <table className="min-w-full bg-gray-100 table-auto text-left my-6 border border-gray-600">
      <thead className="bg-gray-200 text-gray-700 text-lg">
        <tr>
          {showIndex && <th className="border border-gray-600 px-4 py-2 w-1/12">#</th>}
          <th className="border border-gray-600 px-4 py-2 w-1/6">Image</th>
          <th className="border border-gray-600 px-4 py-2 w-2/6">Title</th>
          <th className="border border-gray-600 px-4 py-2 w-1/6">Category</th>
          <th className="border border-gray-600 px-4 py-2 w-1/6">Date</th>
          <th className="border border-gray-600 px-4 py-2 w-1/6">Actions</th>
        </tr>
      </thead>
      <tbody>
        {articles.map((article, index) => (
          <tr key={article.id} className="border-b border-gray-600 hover:bg-gray-100 transition">
            {showIndex && <td className="h-40 px-4 border border-gray-600 text-center">{startIndex + index + 1}</td>}

            <td className="h-40 px-4 border border-gray-600 flex justify-center items-center">
              <img src={article.featuredImage || '/placeholder.png'} alt={article.title} className="h-12 object-cover" />
            </td>

            <td
              className="h-20 px-4 border border-gray-600 text-secondary font-semibold cursor-pointer hover:underline"
              onClick={() => window.open(`${process.env.REACT_APP_BASE_URL}/blog/${slugify(article.title)}`, '_blank')}
            >
              {truncate(article.title, 60)}
            </td>

            <td className="h-20 px-4 border border-gray-600">{article.category}</td>
            <td className="h-20 px-4 border border-gray-600">{formatDate(article.dateCreated)}</td>

            <td className="h-20 px-4 border border-gray-600">
              <div className="flex justify-between items-center gap-2">
                <button
                  onClick={() => onSetFeatured(article.id)}
                  className={`p-2 rounded ${article.isFeatured ? 'bg-yellow-500 text-white' : 'text-yellow-500'}`}
                  title="Toggle Featured"
                >
                  <FontAwesomeIcon icon={faStar} />
                </button>

                <button
                  onClick={() => onEdit(article.id)}
                  className="p-2 rounded text-primary hover:bg-primary hover:text-white"
                  title="Edit Article"
                >
                  <FontAwesomeIcon icon={faPen} />
                </button>

                <button
                  onClick={() => onDelete(article.id)}
                  className="p-2 rounded text-red-500 hover:bg-red-500 hover:text-white"
                  title="Delete Article"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ArticlesTable;
